import React, { useEffect, useState } from 'react';
import { Coins } from 'lucide-react';
import api from '@/api';
import PillHero from './PillHero';

const fmtInr = (n) =>
  n == null ? '—' : '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });

const badgeLabel = (pct, fallback) =>
  pct == null ? fallback : `${pct >= 0 ? '+' : ''}${pct.toFixed(2)}% 7d`;

export default function IndiaBullionHero() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const res = await api.getIndiaBullionToday();
        if (!cancel) setData(res);
      } catch (_e) {
        if (!cancel) setData({ available: false });
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => { cancel = true; };
  }, []);

  if (loading || !data?.available) return null;

  const asOf = data.as_of
    ? new Date(data.as_of).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
    : '';

  return (
    <PillHero
      testId="india-bullion-hero"
      Icon={Coins}
      accent="#FBBF24"
      title="India Bullion Today"
      subtitle={`As of ${asOf} · 1 USD = ₹${data.usd_inr}`}
      tiles={[
        { label: 'GOLD 24K · 10g', primary: fmtInr(data.gold_24k_inr_per_10g),
          badgeDirection: data.gold_direction, badgeLabel: badgeLabel(data.gold_weekly_change_pct, 'This week') },
        { label: 'GOLD 22K · 10g', primary: fmtInr(data.gold_22k_inr_per_10g),
          badgeDirection: data.gold_direction, badgeLabel: badgeLabel(data.gold_weekly_change_pct, 'This week') },
        { label: 'SILVER · 1 kg', primary: fmtInr(data.silver_inr_per_kg),
          badgeDirection: data.silver_direction, badgeLabel: badgeLabel(data.silver_weekly_change_pct, 'This week') },
      ]}
      sourceNote={data.source_note}
    />
  );
}
